import React, { useCallback, useMemo } from "react";
import { DataTable, Text, useClientTable } from "@pushpress/shared-components";
import { DataTableProps } from "@pushpress/shared-components/build/components/data/DataTable";
import { ClassTypeRowFragment } from "./ClassTypes-generated.hooks";
import styles from "./ClassTypesTable.module.scss";
import { ObjectToBeDefined } from "../../../types/types";

interface ClassTypesTableProps<K extends string>
  extends Pick<DataTableProps<any, K>, "data" | "renderRowMenu" | "loading"> {
  data: ClassTypeRowFragment[];
}

function ClassTypesTable<K extends string>(props: ClassTypesTableProps<K>) {
  const { data: dataProp, ...other } = props;

  const columns = useMemo(
    () => [
      {
        key: "name",
        header: "Name",
        isSortable: true,
        cell: (row: ClassTypeRowFragment) => {
          return (
            <div>
              <span
                className={styles.color}
                style={{ background: row.color }}
              />
              <Text variant="body-lg" component="span">
                {row?.name || "- -"}
              </Text>
            </div>
          );
        },
      },
      {
        key: "isFreeSession",
        header: "Free",
        isSortable: true,
        hideOnMobile: true,
        hideOnDetails: true,
        cell: (row: ClassTypeRowFragment) => {
          return (
            <Text variant="body-lg">{row.isFreeSession ? "Yes" : "No"}</Text>
          );
        },
      },
    ],
    [],
  );

  const { data, sort, handleSort } = useClientTable({
    data: dataProp,
    columns,
    defaultSort: { key: "name", order: "asc" },
  });

  const getRowId = useCallback((row: ObjectToBeDefined) => {
    return row.uuid;
  }, []);

  return (
    <DataTable
      {...other}
      data={data}
      columns={columns}
      sort={sort}
      getRowId={getRowId}
      onSort={handleSort}
    />
  );
}

export default ClassTypesTable;
